import { styled } from '@material-ui/core';
import { Avatar } from '@room-match/shared-ui-components';

export const AddRepresentativesFormListAgencyRenderOptionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 20,
  padding: 10,
}));

export const AddRepresentativesFormListAgencyRenderOptionAvatar = styled(Avatar)({
  width: 25,
  height: 25,
});

export const AddRepresentativesFormListAgencyRenderOptionDetailsContainer = styled('div')({});
